import { render } from "./IndexMessage.vue?vue&type=template&id=0b2c18ea"
import script from "./IndexMessage.vue?vue&type=script&lang=js"
export * from "./IndexMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__